import { Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({
  selector: '[hoverClass]'
})
export class HoverClassDirective implements OnInit {
  @Input() hoverClass: string;
  @Input() hoverClassDelayMls: number;

  hoveredUpon = false;
  activeTimeout: any;

  constructor(private _elementRef: ElementRef) {
  }

  ngOnInit(): void {

    this._elementRef.nativeElement.addEventListener('mouseover', () => {
      // if (this.hoveredUpon) {
      //   //if this is a consecutive event and we are already being hovered on no need to proceed.
      //   return;
      // }

      this.hoveredUpon = true;
      this.clearTimer();
      if (this.hoverClass) {
        if (this.hoverClassDelayMls) {
          this.activeTimeout = setTimeout(() => {
            if (this.hoveredUpon) {
              //if after the timeout we are still hovered upon
              this._elementRef.nativeElement.classList.add(this.hoverClass);
            }
          }, this.hoverClassDelayMls);
        } else {
          this._elementRef.nativeElement.classList.add(this.hoverClass);
        }
      }
    });

    this._elementRef.nativeElement.addEventListener('mouseleave', () => {
      this.hoveredUpon = false;
      this.clearTimer();
      if (this.hoverClass) {
        this._elementRef.nativeElement.classList.remove(this.hoverClass);
      }
    });

  }

  clearTimer() {

    if (this.activeTimeout) {
      clearTimeout(this.activeTimeout);
      this.activeTimeout = null;
    }
  }
}

